<template>
  <mc-button v-if="showBeamer" icon="icon-bell" :class="[BEAMER_TRIGGER_CSS_CLASS, 'nav-menu-plugin-button']">
    <span class="nav-menu-plugin-button-text">What's new</span>
  </mc-button>
 </template>

<script setup lang="ts">
import { computed } from 'vue';
import McButton from '@/components/ui/McButton.vue';
import { BEAMER_TRIGGER_CSS_CLASS } from '@/constants/shared';
import { useUserProfileStore } from '@/store/userProfileStore';

const userProfileStore = useUserProfileStore();
const showBeamer = computed(() => userProfileStore.showBeamer);
</script>